import AuditProvider from 'components/modules/service/Audit/AuditProvider';
import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import HistoryIcon from '@material-ui/icons/History';
import ExpansionList from '../../../../common/ExpansionList';
import { columnMeta, createSearchFields } from './History/config/index';
import ExpandablePanel from '../../../../common/ExpandablePanel';
import {
  useIsFspConfigUpdating,
  useIsProfileLoading,
} from '../../../implementation/Fsp/Detail/common';
import GuestDetailsRender from './History/config/DetailsRender/GuestDetailsRender';
import GuestHistoryActionsRenderer from './History/config/GuestHistoryActionsRenderer';

const defaultExpandablePanelProps = {
  heightOffset: 68,
  icon: HistoryIcon,
  id: 'history',
  scrollTopOffset: 0,
  title: 'Transaction History',
};

function guestDetailsRender(transaction) {
  return <GuestDetailsRender transaction={transaction} />;
}

const GuestTransactionHistoryPanel = ({
  items,
  heightOffset,
  scrollTopOffset,
  onOpen,
  onUpdateSuccess,
  ...rest
}) => {
  const loading = useIsProfileLoading();
  const updating = useIsFspConfigUpdating();
  const clearAction = () => null;
  const loadAction = () => null;

  const ActionsRenderer = useCallback(
    (props) => (
      <GuestHistoryActionsRenderer
        {...props}
        onUpdateSuccess={onUpdateSuccess}
      />
    ),
    [onUpdateSuccess]
  );

  return (
    <AuditProvider>
      <ExpandablePanel
        fullHeight={false}
        icon={HistoryIcon}
        id="guest-transaction-history"
        showProgress={loading || updating}
        title="Transaction History"
        onChange={(expanded) => {
          if (expanded && onOpen) onOpen();
        }}
      >
        <ExpansionList
          key={`history-${items && items.length}`}
          ActionsRenderer={ActionsRenderer}
          columnMeta={columnMeta}
          countBack
          createSearchFields={createSearchFields}
          detailsRender={guestDetailsRender}
          emptyTitle="No transaction history found."
          ExpandablePanelProps={{
            ...defaultExpandablePanelProps,
            heightOffset: heightOffset || 68,
            scrollTopOffset: scrollTopOffset || 0,
            showProgress: loading || updating,
          }}
          isBusy={loading || updating}
          data={items}
          loadAction={loadAction}
          clearAction={clearAction}
          name="guest-history"
          priorityIndex={3}
          settingType="guest-history"
          {...rest}
        />
      </ExpandablePanel>
    </AuditProvider>
  );
};

GuestTransactionHistoryPanel.propTypes = {
  items: PropTypes.array,
  heightOffset: PropTypes.number,
  scrollTopOffset: PropTypes.number,
  onOpen: PropTypes.func,
  onUpdateSuccess: PropTypes.func,
};

GuestTransactionHistoryPanel.defaultProps = {
  items: [],
  heightOffset: 68,
  scrollTopOffset: 0,
  onOpen: undefined,
  onUpdateSuccess: undefined,
};

export default memo(GuestTransactionHistoryPanel);
